function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0,65.681 20.683,54.341 35.991,59.661 42.684,56.345 50.667,59.661 69.332,57.663 91.318,40.997  102.672,37.66 99.322,47.675 121.333,56.345 126.008,52.996 133.971,62.324 138.659,62.324 146.649,72.326 155.999,75.683  157.344,87.668 155.999,94.327 173.325,92.329 181.302,95.665 189.36,114.343 194.008,111 200,115.661 200,121.016 190.664,134.347  173.325,128.999 162.019,134.347 162.019,142.344 155.999,144.334 146.649,154.35 137.354,147.69 137.354,142.344 122.651,145.68  107.351,162.34 98.004,160.349 64.67,134.347 61.334,122.334 53.337,115.661 39.333,89.006 25.351,94.327 12.665,91.011  8.004,80.989 8.004,71.008 "
});

var Svg29 = function Svg29(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TLAX",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg29, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/29.c79462e2.svg";
export { ForwardRef as ReactComponent };